import { useState, type FormEvent } from "react";
import { useAuth } from "./authContext";

export function LoginPage() {
  const auth = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    setError(null);
    try {
      await auth.login(username, password);
      setPassword("");
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Could not sign in");
    } finally {
      setPending(false);
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-card">
        <img className="brand-mark" src="/favicon.svg" alt="Auto Pools" />
        <h1>Auto Pools</h1>
        <p className="lead">Private liquidity management panel.</p>
        {auth.error && (
          <div className="inline-alert error" role="alert">
            Authentication service unavailable: {auth.error}
          </div>
        )}
        {!auth.configured ? (
          <div className="inline-alert warning" role="alert">
            <strong>The operator account has not been created.</strong>
            <span>
              Create it through the private server setup channel. The password is entered in the
              terminal and is never displayed. Public registration is disabled.
            </span>
          </div>
        ) : (
          <form
            onSubmit={(event) => {
              void submit(event);
            }}
            className="stack"
          >
            <label>
              Username
              <input
                autoComplete="username"
                value={username}
                onChange={(event) => {
                  setUsername(event.target.value);
                }}
                required
                autoFocus
              />
            </label>
            <label>
              Password
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                required
              />
            </label>
            {error && (
              <p className="form-error" role="alert">
                {error}
              </p>
            )}
            <button className="button primary wide" disabled={pending}>
              {pending ? "Checking…" : "Sign in"}
            </button>
          </form>
        )}
        <p className="security-note">
          The session uses a secure HttpOnly cookie. Trading uses your signed-in session. Sensitive
          Settings changes still require your password.
        </p>
      </section>
    </main>
  );
}
